
import Vue from 'vue';
export default Vue.extend({
  name: 'PickerOrderInvalidAccess',
  mounted: function () {
    this.$router.push('/pick');
  }
});
